import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API_BASE = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

const api = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('supabase_user_id');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const apiService = {
    // Users
    createUser: (data) => api.post('/users', data),
    getCurrentUser: () => api.get('/users/me'),
    
    // Projects
    getProjects: () => api.get('/projects'),
    getProject: (id) => api.get(`/projects/${id}`),
    createProject: (data) => api.post('/projects', data),
    updateProject: (id, data) => api.put(`/projects/${id}`, data),
    deleteProject: (id) => api.delete(`/projects/${id}`),
    
    // Files
    updateFile: (projectId, filePath, content) => 
        api.put(`/projects/${projectId}/files`, { project_id: projectId, file_path: filePath, content }),
    deleteFile: (projectId, filePath) => 
        api.delete(`/projects/${projectId}/files/${filePath}`),
    
    // Code Generation
    generateCode: (data) => api.post('/generate', data),
    
    // Chat History
    getChatHistory: (projectId) => api.get(`/projects/${projectId}/chat-history`),
    getChatSession: (projectId, sessionId) => api.get(`/projects/${projectId}/chat-history/${sessionId}`),
    deleteChatSession: (projectId, sessionId) => api.delete(`/projects/${projectId}/chat-history/${sessionId}`),
    
    // Finalization
    finalizeProject: (projectId) => api.post(`/projects/${projectId}/finalize`),
    getSystemPrompt: () => api.get('/system-prompt'),
    
    // Deployment
    deployProject: (projectId) => api.post('/deploy', { project_id: projectId }),
    undeployProject: (projectId) => api.delete(`/deploy/${projectId}`),
    
    // Models
    getModels: () => api.get('/models'),
    
    // GitHub Integration
    getGitHubAuthUrl: () => api.get('/github/authorize'),
    handleGitHubCallback: (code, state) => api.get('/github/callback', { params: { code, state } }),
    connectGitHub: (data) => api.post('/github/connect', data),
    disconnectGitHub: () => api.delete('/github/disconnect'),
    getGitHubStatus: () => api.get('/github/status'),
    getGitHubRepos: () => api.get('/github/repos'),
    createGitHubRepo: (data) => api.post('/github/repos', data),
    saveToGitHub: (data) => api.post('/github/save', data),
    importFromGitHub: (data) => api.post('/github/import', data),
    getRepoBranches: (owner, repo) => api.get(`/github/repos/${owner}/${repo}/branches`),
};

export default api;
